var XPortal = XPortal || {};
XPortal.AutofillFields = (function () {
    var self = {
        debug: false,
        models: [],
        relations: [],
        timeOut: 300,
        initModel: function (storeModel) {
            const model = storeModel.model;
            const entityUId = (storeModel.entity || {}).UniqueId || "";
            const gridPgSttgs = $(model.selector).data("stgs-pg") || {};

            const reqItem = {
                nodeId: model.NodeId,
                modelName: model.modelName,
                entityUId: entityUId,
                parentInfo: model.ParentInfo || XPortal.Grid.GetModelParentInfo(model.modelName),
                parentModelName: XPortal.Grid.GetModelParentName(model.modelName) || model.modelName,
                autofillFieldsSetup: model.AutofillFields || gridPgSttgs.AutofillFields,
                selector: model.selector,
                batchUpdateTimeout: null,
                batchUpdateTimeouts: {},
                requestNumber: 0, // Tracks the latest update request to prevent outdated updates
                alias: model.EntityAlias || model.Alias,
            };

            const entityIndex = self.models.findIndex(item => item.nodeId === reqItem.nodeId);

            if (entityIndex !== -1) 
                self.models[entityIndex] = Object.assign(self.models[entityIndex], reqItem);
             else
                self.models.push(reqItem);            
        },
        updateModel: function (storeModel, action, storeState) {
            if (!action) return;

            const changedModelName = storeModel ? storeModel.model.modelName : action.model || action.modelName || "";

            const fieldsToUpdate = getAffectedFields(action, changedModelName);
            if (!fieldsToUpdate.length) return;

            const changedModel = findAFIllModel(changedModelName);

            sendBatchUpdate(changedModel, fieldsToUpdate, storeModel, action, storeState)
                .then(result => {
                    if (self.debug) {
                        const afnames = result.updatedFields.map(f => f.DependedFieldName).join(",");
                        const fvalues = result.data.UpdatedAutofillFields.map(f => f.DependedFieldName + "=" + f.Value).join(",\r\n");
                        console.log("-autofill updated:" + changedModelName + ", " + (action.field || {}).field + '>>>' + afnames, { action, result, fvalues });
                    }
                }).catch(error => {
                    console.log("-autofill error:" + changedModelName + ", " + (action.field || {}).field, { error, fieldsToUpdate, action });
                });
        }
    };

    function getAffectedFields(action, changedModelName) {
        const afield = action.field;
        const chFieldName = afield && afield.field ? afield.field.toLowerCase() : "";

        const changedModel = findAFIllModel(changedModelName);

        if (!changedModel) return [];
        const isDeleting = (action.type || "") == XPortal.Redusers.ACTIONS.DELETED_ENTITY;
        const directFields = isDeleting ? [] : getDirectModelFields(changedModel, chFieldName);
        const other_Fields = getOtherModelsFields((changedModel.alias || "").toLowerCase(), chFieldName, changedModelName);
        return [...directFields, ...other_Fields];
    };
    function getDirectModelFields(changedModel, chFieldName) {
        const filteredSetups = !chFieldName ? changedModel.autofillFieldsSetup : changedModel.autofillFieldsSetup.filter(setup =>
            setup.AffectingFields.some(af =>
                af.toLowerCase() == chFieldName
            )
        );

        return enrichSetupFields(filteredSetups, changedModel);
    };
    function getOtherModelsFields(changedEntityAlias, changedFieldName, changedModelName) {
        const x = self.models.flatMap(m => {
            if (m.modelName == changedModelName) return [];
            const aliasFields = m.autofillFieldsSetup.filter(f => f.DependedEntity.toLowerCase() == changedEntityAlias);
            const affcdFields = !changedFieldName ? aliasFields : aliasFields.filter(f => f.AffectingFields.some(fn => fn.toLowerCase() == changedFieldName));
            return enrichSetupFields(affcdFields, null, m.alias, m.nodeId);
        });

        return x;
    }

    function findAFIllModel(modelName) {
        return self.models.find(model => model.modelName == modelName);
    };

    function enrichSetupFields(setupFields, model, modelname, nodeId) {
        if (!setupFields) return [];
        return setupFields.map(autoFillFld => ({
            ...autoFillFld,
            uniqueId: model && model.uniqueId,
            alias: modelname || model.alias,
            nodeId: nodeId || model.nodeId
        }));
    };

    function sendBatchUpdate(model, updatedFields, storeModel, action, storeState) {
        return new Promise((resolve, reject) => {
            var entityUniqueId = model.entityUId || (storeModel && storeModel.entity ? storeModel.entity.UniqueId : "") || "";            
            const requestData = getRequestModel(model, updatedFields, storeModel, action, storeState);
            clearTimeout(model.batchUpdateTimeouts[entityUniqueId]||-1);
            AutofillFieldLoader("Start", updatedFields);
            model.batchUpdateTimeouts[entityUniqueId] = setTimeout(function () {
                XPortal.Utils.waitFor(function () {                    
                    const depEntAlias = updatedFields.map(x => x.DependedEntity).filter(x => x && x.trim());
                    const depActiveMs = self.models.filter(m => m.requesting == true && depEntAlias.find(rma => rma == m.alias) != null);
                    if (depActiveMs && depActiveMs.length) return false;
                    
                    if (!requestData.updatedFields || !requestData.updatedFields.length)
                        return resolve(null);

                    executeRequest(model, updatedFields, requestData, action)
                        .then(o => resolve(o))
                        .catch(e => reject(e));
                    return true;
                }, XPortal.Utils.waitFor, 10, 10000);

            }, self.timeOut);
        });
    };
    function executeRequest(model, updatedFields, requestData, action) {
        const fnames = updatedFields.map(x => x.DependedFieldName + (model.nodeId != x.nodeId ? ":" + x.nodeId : "")).join(",");
        console.log("-autofill requesting: " + model.alias + ", " + (action.field || {}).field + '>>>' + fnames, { action, requestData });
        return new Promise((resolve, reject) => {
            model.requesting = true;
            $.ajax({
                url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/Autofill/Recalculate?pfs=" + model.nodeId + "_" + model.requestNumber + ":" + fnames + "/" + (model.alias || "").replaceAll(" ", "_")),
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                data: JSON.stringify(requestData),
                success: function (data) {
                    model.requesting = false;
                    updateFields(data, action);
                    resolve({ data, updatedFields });

                    setTimeout(() => {
                        AutofillFieldLoader("Finish", updatedFields);
                    }, 500);
                },
                error: function (xhr, status, error) {
                    model.requesting = false;
                    console.error("Autofill server update error:", xhr.responseText, status, error);
                    reject(xhr);

                    setTimeout(() => {
                        AutofillFieldLoader("Finish", updatedFields);
                    }, 500);
                }
            });
        });
    }
    function AutofillFieldLoader(status, updatedFields) {
        if (!Array.isArray(updatedFields) || updatedFields.length === 0) return;

        $(".default-autofill-hidden").each(function () {
            const hiddenField = $(this);
            const fieldName = hiddenField.data("metadata-fieldname");

            const matchingFieldContainer = $(".field-cntr.form-group").filter(function () {
                return $(this).find(`[data-metadata-fieldname="${fieldName}"]`).length > 0;
            });
            matchingFieldContainer.addClass("default-autofill");
        });

        updatedFields.forEach(field => {
            const fieldName = field.DependedFieldName;
            let defAutofillFields = $(".default-autofill");
            if (!defAutofillFields || defAutofillFields.length === 0) return;
            const matchingContainers = defAutofillFields.filter(function () {
                return $(this).find(`[data-metadata-fieldname="${fieldName}"]`).length > 0;
            });

            if (matchingContainers.length === 0) return;

            switch (status) {
                case "Start":
                    matchingContainers.addClass("loading");
                    break;
                case "Finish":
                    matchingContainers.removeClass("loading");
                    break;
                default:
                    console.warn("SetAutofillFieldStatus: Unknown status", status);
                    break;
            }
        });
    };
    function updateFields(data, action) {
        const updFields = data.UpdatedAutofillFields;
        const isRemoveLine = action.type === "DELETED_ENTITY";

        if (!updFields) return;

        const modelsToSearch = isRemoveLine
            ? self.models.filter(m => m.modelName.includes("detail"))
            : self.models;

        updFields.forEach(p => {
            const model = modelsToSearch.find(m =>
                m.autofillFieldsSetup.some(x => x.DependedFieldKey === p.DependedFieldKey)
            );
            if (model)
                XPortal.Store.DispatchByName(model.modelName, p.DependedFieldName, p.Value);
        });
    };


    function getRequestModel(model, updatedFields, storeModel, action, storeState) {
        let modified = storeModel && storeModel.entity
            ? convertEditEntityToSave(storeModel.entity, null, true)
            : { nodeId: model.nodeId };

        if (!modified.UniqueId) modified.UniqueId = model.entityUId || (storeModel && storeModel.entity ? storeModel.entity.UniqueId : "") || "";
        if (!modified.EntityAlias) modified.EntityAlias = model.alias;
        if (!storeState) storeState={};
        return Object.assign({}, modified, {
            updatedFields,
            requestNumber: model.requestNumber++,
            pageItems: getPageItems(storeModel, action, storeState),
            gridItems: getCurrentGridItems(model,storeModel, action, storeState),
            parentInfo: model.parentInfo
        });
    };


    function getCurrentGridItems(model, storeModel, action, storeState) {
        const cModel = XPortal.Store.GetModelByName(model.modelName, (storeState ||{}).pageModels);
        if (!cModel || !cModel.GridModel) return null;

        return extractGridItems(cModel, storeState.pageModels);
    };

    function getPageItems(storeModel, action, storeState) {
        let pItems = [];
        const sModels = sortItems();
        sModels.forEach(({ modelName }) => {
            const cModel = XPortal.Store.GetModelByName(modelName, storeState.pageModels);
            if (cModel && cModel.entity && !cModel.GridModel) {
                pItems.push(extractDetailModels(cModel));
            }
            if (cModel && cModel.GridModel) {
                pItems.push(...extractGridItems(cModel, storeState.pageModels));
            }
        });
        return pItems;
    };

    function extractDetailModels(cModel) {
        return convertEditEntityToSave(cModel.entity, cModel.model.parentInfo, true);
    };

    function extractGridItems(cModel, pageModels) {
        const gridItems = getGridItems(cModel) || [];
        const prtModel = XPortal.Store.GetParentModel(cModel, pageModels);
        const prntInfo = cModel.GridModel.options.pageData.details.parentInfo;
        return gridItems.map(item => {
            const convertedItem = convertEditEntityToSave(item, prntInfo, true);
            if (!convertedItem.NodeId) convertedItem.NodeId = cModel.model.NodeId;
            return convertedItem;
        });
    };

    function convertEditEntityToSave(item, prntInfo, excludeEmptyFields) {
        var r = XPortal.Store.ConvertEditEntityToSave(item, prntInfo);
        if (excludeEmptyFields || !r || !r.Fields) {
            const rflds = [];
            _.each(r.Fields, (f) => {
                if (f.Data !== "") rflds.push(f);
            });
            r.Fields = rflds;
        }
        return r;
    };
    function getGridItems(cModel) {
        let items = cModel.GridModel.dataSource.view();
        return items;
    };



    function sortItems() {
        return self.models.sort((a, b) => {
            const aIsDetail = a.modelName.includes("detail");
            const bIsDetail = b.modelName.includes("detail");

            if (!aIsDetail && bIsDetail) return -1; // Grid first
            if (aIsDetail && !bIsDetail) return 1; // Detail later
            return 0;
        });
    };

    return self;
})();

